import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import styled from 'styled-components';
import JwtService from '../../auth/services/jwtService';
import { ReactComponent as Logo } from '../../assets/svg/e_huquqshunos.svg';
import { useTranslation } from 'react-i18next';

const StyledLogo = styled.div`
    width: 150px;
    height: 150px;
    margin: auto;

    & svg {
        width: 100%;
        height: 100%;
    }
`;

function SignOutPage() {
  const { t } = useTranslation();
  useEffect(() => {
    setTimeout(() => {
      JwtService.logout();
    }, 1000);
  }, []);

  return (<div className="flex flex-col flex-auto items-center sm:justify-center min-w-0">
      <Paper
        className="flex items-center w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-16 sm:p-48 sm:rounded-2xl sm:shadow">
        <div className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0 justify-center items-center">
          {/* <img className="w-48 mx-auto" src="assets/images/logo/logo.svg" alt="logo" /> */}
          <StyledLogo>
            <Logo />
          </StyledLogo>
          <Typography className="mt-32 text-4xl font-extrabold tracking-tight leading-tight text-center">
            {t('logout.text')}
          </Typography>
        </div>
      </Paper>
    </div>);
}

export default SignOutPage;
